import { Card, CardContent } from '@mui/material';
import classNames from 'classnames';
import React from 'react';

interface ReusableCardProps {
	number: number;
	title: React.ReactNode;
	label?: string;
	numberColor?: string;
	mdMedia?: boolean;
	className?: string;
	onClick?: () => void;
}

export const PromotionCard: React.FC<ReusableCardProps> = ({
	number,
	title,
	label,
	numberColor,
	mdMedia,
	onClick,
}) => {
	return (
		<Card
			elevation={2}
			className={classNames(
				'flex justify-center !w-full items-center !rounded-[12px] !shadow-custom-button max-sm:p-[20px] h-full'
			)}
			onClick={onClick}
		>
			<CardContent className="flex flex-col !p-0">
				<div className="flex flex-row items-center">
					<div className="text-5xl" style={{ color: numberColor }}>
						{number}
					</div>
					<div className="h-[34px] bg-[#CFCCD6] w-[1px] mx-5" />
					<div
						className={classNames({
							'max-lg:flex max-lg:text-center': mdMedia,
						})}
					>
						{label && (
							<div
								className="bg-primary text-[#FFF] text-[10px] mb-[8px] pt-[1px] pb-[1px] pl-[5px] pr-[5px]"
								style={{ borderRadius: '5px', width: 'max-content' }}
							>
								{label}
							</div>
						)}
						<span className="text-dark font-[500] text-[16px]">{title}</span>
					</div>
				</div>
			</CardContent>
		</Card>
	);
};
